<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="出库作业" @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-tabs @click="onClick">
      <van-tab title="任务汇总">
        <van-field :value="storageRoom.name" label="库房" name="storageRoomPicker" readonly right-icon="clear" @focus="showStorageRoom=true" @click-right-icon="clearStorageRoom"/>
        <van-popup v-model="showStorageRoom" position="bottom">
          <van-picker :columns="storageRooms" show-toolbar value-key="name" @cancel="showStorageRoom = false" @confirm="onStorageRoomSelected"/>
        </van-popup>
        <van-field :value="zone.name" label="区域" name="zonePicker" readonly right-icon="clear" @focus="showZone=true" @click-right-icon="clearZone"/>
        <van-popup v-model="showZone" position="bottom">
          <van-picker :columns="zones" show-toolbar value-key="name" @cancel="showZone=false" @confirm="onZoneSelected"/>
        </van-popup>
        <van-field :value="wave" label="波次" name="wavePicker" readonly right-icon="clear" @focus="showWave=true" @click-right-icon="clearWave"/>
        <van-popup v-model="showWave" position="bottom">
          <van-picker :columns="waves" show-toolbar value-key="name" @cancel="showWave=false" @confirm="onWaveSelected"/>
        </van-popup>
        <vxe-table :data="list" :loading="loading">
          <vxe-column fixed="left" type="seq" width="40"/>
          <vxe-column field="title" title="任务类别"/>
          <vxe-column field="count" title="任务数"/>
          <vxe-column field="zone" title="库区"/>
        </vxe-table>
        <van-tabbar fixed placeholder>
          <van-tabbar-item>
            <van-row gutter="20">
              <van-col span="8">
                <van-button block round style="margin: 8px;" type="info" @click="clear">清空</van-button>
              </van-col>
              <van-col span="8">
                <van-button block round style="margin: 8px;" type="info" @click="refreshList">刷新</van-button>
              </van-col>
              <van-col span="8">
                <van-button :loading="loading" block round style="margin: 8px;" type="primary" @click="obtain">索取</van-button>
              </van-col>
            </van-row>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
      <van-tab title="索取未确认">
        <div style="height: 60%">
          <vxe-table ref="tasks" :data="tasks" :loading="loading">
            <vxe-column fixed="left" type="seq" width="40"/>
            <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="pickingOrder.operationType" title="business.label.operationType" width="80"/>
            <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="pickingOrder.packType" title="business.label.packType" width="80"/>
            <vxe-column field="pickingOrder.no" title="任务号"/>
          </vxe-table>
        </div>
        <van-tabbar fixed placeholder>
          <van-tabbar-item>
            <van-row gutter="20">
              <van-col span="12">
                <van-button block round style="margin: 8px;" type="info" @click="refreshTask">刷新</van-button>
              </van-col>
              <van-col span="12">
                <van-button block round style="margin: 8px;" type="primary" @click="getDetail">索取</van-button>
              </van-col>
            </van-row>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { getOutBoundCaseData, getOutBoundReplenishData, getUser, getUserId } from '@/pdaView/utils'
import { Dialog, Toast } from 'vant'
import { getEnums } from '@/utils/util'

export default {
  data() {
    return {
      loading: false,
      username: getUser().name,
      storageRoom: { id: null, name: '' },
      zone: { id: null, name: '' },
      wave: null,
      storageRooms: [],
      zones: [],
      waves: [],
      showStorageRoom: false,
      showZone: false,
      showWave: false,
      operationTypes: [],
      packTypes: [],
      list: [],
      tasks: []
    }
  },
  created() {
    getEnums('OperationType').then(result => {
      this.operationTypes = result
      return getEnums('PackType')
    }).then(result => {
      this.packTypes = result
    }).finally(() => {
      this.getStorageRooms()
      this.getWaves()
      this.refreshList()
    })
  },
  methods: {
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onClickLeft() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onClick(that) {
      if (that === 0) {
        this.refreshList()
      } else {
        this.refreshTask()
      }
    },
    getStorageRooms() {
      const args = {
        'picker.id': getUserId(),
        application: 3,
        available: true,
        special: false
      }
      findAll('pickerConfigFactory', args).then(res => {
        if (res.success && res.result.length > 0) {
          this.storageRooms = []
          res.result.map(row => {
            this.storageRooms.push({
              id: row.storageRoom.id,
              name: row.storageRoom.name
            })
          })
        }
      })
    },
    onStorageRoomSelected(item) {
      this.storageRoom = item
      this.showStorageRoom = false
      this.getZones()
    },
    getZones() {
      const args = {
        'storageRoom.id': this.storageRoom.id,
        'working': true,
        available: true
      }
      findAll('zoneFactory', args).then(res => {
        if (res.success && res.result.length > 0) {
          this.zones = res.result.map(item => {
            return { id: item.id, name: item.name }
          })
        }
      })
    },
    onZoneSelected(item) {
      this.zone = item
      this.showZone = false
    },
    getWaves() {
      const args = {
        'user.id': getUserId(),
        application: 3,
        special: false
      }
      findAll('pickingPdaTaskWaveListFactory', args).then(res => {
        if (res.success && res.result.length > 0) {
          this.waves = []
          res.result.map(row => {
            this.waves.push({
              name: row.wave
            })
          })
        }
      })
    },
    onWaveSelected(item) {
      this.wave = item.name
      this.showWave = false
    },
    refreshList() {
      this.loading = true
      this.list = []
      const args = {
        'user.id': getUserId(),
        application: 3,
        wave: this.wave,
        'workstation.id': this.zone.id,
        special: false
      }
      findAll('pickingPdaTaskFactory', args).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    refreshTask() {
      this.loading = true
      const args = {
        workMode: 3,
        'user.id': getUserId(),
        device: false,
        special: false
      }
      findAll('pickingOrderObtainedFactory', args).then(res => {
        if (res.success) {
          this.tasks = res.result
        }
      }).finally(() => this.loading = false)
    },
    clear() {
      this.storageRoom = { id: null, name: '' }
      this.zone = { id: null, name: '' }
      this.wave = null
      this.zones = []
      this.refreshList()
    },
    clearStorageRoom() {
      this.storageRoom = { id: null, name: '' }
      this.zone = { id: null, name: '' }
      this.zones = []
    },
    clearZone() {
      this.zone = { id: null, name: '' }
    },
    clearWave() {
      this.wave = null
    },
    obtain() {
      if (!this.storageRoom.name) {
        Dialog({ message: '请先选择库房' })
        return
      }
      this.loading = true
      const args = {
        'workMode': 3,
        'storageRoom.id': this.storageRoom.id,
        'workstation.id': this.zone.id,
        wave: this.wave
      }
      post(api.pickingObtain, { type: 'commandObtainer' }, args).then(res => {
        if (res.success) {
          if (res.result.operationType === 2) {
            if (res.result.packType === 1) {
              this.getPrintData(res.result.no)
            }
            this.$router.push({ name: 'CasePicking', params: { parent: 'PickingHall', pickingOrderId: res.result.id } })
          } else if (res.result.operationType === 3) {
            this.getPrintData2(res.result.no)
            this.$router.push({ name: 'Replenishing', params: { parent: 'PickingHall', pickingOrderId: res.result.id } })
          }
        } else {
          Toast(res.result)
        }
      }).finally(() => this.loading = false)
    },
    getDetail() {
      const currentRow = this.$refs.tasks.getCurrentRecord()
      if (currentRow.pickingOrder.operationType === 2) {
        this.$router.push({ name: 'CasePicking', params: { parent: 'PickingHall', pickingOrderId: currentRow.pickingOrder.id } })
      } else if (currentRow.pickingOrder.operationType === 3) {
        this.$router.push({ name: 'Replenishing', params: { parent: 'PickingHall', pickingOrderId: currentRow.pickingOrder.id } })
      }
    },
    getPrintData(pickingOrderNo) {
      const args = {
        'query.no': 'casePickingTagPrint',
        'sql': null,
        'args': {
          barcodeNo: null,
          pickingOrderNo: pickingOrderNo
        }
      }
      getOutBoundCaseData(args)
    },
    getPrintData2(pickingOrderNo) {
      const args = {
        'query.no': 'replenishTagPrint',
        'sql': null,
        'args': {
          barcodeNo: null,
          pickingOrderNo: pickingOrderNo
        }
      }
      getOutBoundReplenishData(args)
    }
  }
}
</script>